import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaCashflowPage } from './plaza-cashflow';

@NgModule({
  declarations: [
    PlazaCashflowPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaCashflowPage),
    TranslateModule.forChild()
  ],
})
export class PlazaCashflowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-cashflow/plaza-cashflow.module.ts